<template>
  <div
      class="vform-legend"
      :style="{
        color: fontColor,
      }"
  >
    <div
        :style="{
                  backgroundColor: backgroundColor,
                  color: fontColor,
                  borderColor: borderColor,
                  textAlign: titleAlignment
               }"
        class="w-100 info-container-row">
      <span v-if="itemLetter">{{ itemLetter }}) </span>{{ itemName }}
    </div>
    <div class="w-100 mb-1 container-fluid">
      <div v-if="metaValuesFilteredByMetaFields">
        <div class="row"
             v-for="(val, index2) in metaValuesFilteredByMetaFields"
             :key="index2"
             :class="['info-container-row', index2 % 2 === 0 ? 'zebra-stripe' : '']"
             :style="{
                  backgroundColor: backgroundColor,
                  color: fontColor,
                  borderColor: index2 !== metaValuesFilteredByMetaFields.length -1 ? borderColor : '',
                  textAlign: textAlignment
               }">
          <span class="col-4 info-container-name">{{ getMetaValueKey(val) }}</span>
          <span v-if="getFinalMetaValue(val)" class="col-8 info-container-meta">{{ getFinalMetaValue(val) }}</span>
          <span v-else class="col-8 info-container-meta"> - </span>
        </div>
      </div>
      <div v-else>
        -
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PartInfoDisplay",
  props: {
    itemLetter: {type: String, required: true},
    itemName: {type: String, required: true},
    metaFields: {type: Array, default: () => []},
    metaValues: {type: Array, default: () => []},
    fontColor: {type: String, default: ''},
    backgroundColor: {type: String, default: ''},
    borderColor: {type: String, required: false, default: ''},
    titleAlignment: {type: String, default: 'left'},
    textAlignment: {type: String, default: 'left'},
  },
  computed: {
    metaValuesFilteredByMetaFields() {
      if (this.metaFields.length && this.metaValues.length) {
        return this.metaValues.filter(val => this.metaFields.includes(this.getMetaValueFieldId(val)));
      } else {
        return this.metaValues;
      }
    }
  },
  methods: {
    getMetaValueFieldId(val) {
      if (!val) {
        return '';
      } else {
        const {squashedMetaValues} = val;
        const {metaFieldId} = squashedMetaValues;
        return metaFieldId;
      }
    },
    getMetaValueKey(val) {
      if (!val) {
        return '';
      } else {
        const {squashedMetaValues} = val;
        const {metaFieldKey} = squashedMetaValues;
        return metaFieldKey;
      }
    },
    getFinalMetaValue(val) {
      if (!val) {
        return '';
      } else {
        const {squashedMetaValues} = val;
        const {finalMetaValue} = squashedMetaValues;
        return finalMetaValue;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.vform-legend {
  word-break: break-all;
  font-size: 0.9em;

  .info-container-row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.6);
    padding: 0.4em 0.6em;

    &.zebra-stripe {
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
}
</style>